import reducer from './reducer';
import sagas from './sagas';

export default {
  reducer,
  sagas,
};
